{
  "fi": {
    "drivingSchoolLocations": "[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object]"
  },
  "de": {
    "drivingSchoolLocations": ""
  },
  "ee": {
    "drivingSchoolLocations": ""
  },
  "ee-en": {
    "drivingSchoolLocations": ""
  },
  "en": {
    "drivingSchoolLocations": ""
  },
  "is": {
    "drivingSchoolLocations": ""
  },
  "is-en": {
    "drivingSchoolLocations": ""
  },
  "ru": {
    "drivingSchoolLocations": ""
  },
  "sv": {
    "drivingSchoolLocations": ""
  }
}